import { TProductFilters } from 'api/types';
import * as React from 'react';

export enum EProductsFiltersDrawerBlockType {
  RangeSlider = 'rangeSlider',
  CheckboxGroup = 'checkboxGroup',
}

export type TCheckboxGroupFiltersProps = {
  options: Array<{ id: string; label: string }>;
};

export type TRangeSliderFiltersProps = {
  id: string;
  label: string;
  minPrice: number;
  maxPrice: number;
};

export type TProductsFiltersDrawerBlock = {
  id: string;
  blockTitle: string;
  blockType: EProductsFiltersDrawerBlockType;
  blockProps: TCheckboxGroupFiltersProps | TRangeSliderFiltersProps;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialValue: any; // Literally anything
};

type TProductsFiltersDrawerProps = {
  open: boolean;
  onClose: () => void;
  filters: TProductsFiltersDrawerBlock[];
  setSelectedFilters: (filters: TProductFilters) => void;
  selectedFilters: TProductFilters;
};

export type TProductsFiltersDrawer = React.FC<TProductsFiltersDrawerProps>;
